import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-edit-credit-card',
  templateUrl: './edit-credit-card.component.html',
  styleUrls: ['./edit-credit-card.component.css']
})

export class EditCreditCardComponent implements OnInit {

  editCreditCardForm: FormGroup;

  constructor(private _fb: FormBuilder) {
  }

  ngOnInit() {
    this.editCreditCardForm = this._fb.group({
      editCreditCard: this._fb.group({
        CardNumber: new FormControl(''),
        ExpireMonth: new FormControl(''),
        ExpireYear: new FormControl(''),
        CVV: new FormControl('')
      })
    });
  }

  onSubmit() {

  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/edit-credit-card/edit-credit-card.component.ts